module.exports = __webpack_public_path__ + "static/media/1.b62fcff1.png";